module.exports = __webpack_public_path__ + "static/media/figure-Toto.a6c9fb4f.png";